import { getHttpClient } from "./httpClient";
import { ADMIN_URL_CHECK_INS } from "./checkIn.api";

export const postRemarkForCheckIn = (checkInId: number, remark: string) => getHttpClient().post(`${ADMIN_URL_CHECK_INS}/remark/${checkInId}`, { remark });
export const deleteRemarkForCheckIn = (remarkId: number) => getHttpClient().delete(`${ADMIN_URL_CHECK_INS}/remark/${remarkId}`);
